import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';

export const MenuButton = ({ handleClick }) => (
	<IconButton color="inherit" edge="start" onClick={handleClick} sx={{ mr: 2 }}>
		<MenuIcon />
	</IconButton>
);
MenuButton.propTypes = {
	handleClick: PropTypes.func,
};
